module.exports = __webpack_public_path__ + "img/10.57c90aef.png";